import {
  DistributionUsed,
  DistributionUsedNamesEnum,
} from 'src/app/enums/distributionUsed.enum';
import { SampleCensorType } from 'src/app/enums/sampleCensorType.enum';

export function resolveDistributionLabelKey(
  isNormal: boolean | null,
  isLogNormal: boolean | null,
): string {
  return isLogNormal && isNormal
    ? 'Log Normal & Normal'
    : isNormal
      ? 'Normal'
      : isLogNormal
        ? 'Log Normal'
        : 'Rejected';
}

export function resolveDistributionUsedKey(
  distributionUsed: DistributionUsed | null | undefined,
): string | null {
  if (distributionUsed == null) {
    return null;
  }
  return DistributionUsedNamesEnum[distributionUsed] ?? null;
}

export function isExcludedFromStatistics(
  sampleCensorType: SampleCensorType | number | null | undefined,
  substitutedValue: number | null | undefined,
): boolean {
  return sampleCensorType === SampleCensorType.LessThan && substitutedValue == null;
}
